import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { CertificateDeclarationComponent } from './certificate-declaration.component';
import { MatOptionModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MyMaterialModule } from 'src/app/app.material';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import {MAT_LUXON_DATE_FORMATS, LuxonDateAdapter} from '@angular/material-luxon-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { FileDndModule } from '../../shared/file-dnd/file-dnd.module';



@NgModule({
  imports: [
    CommonModule,
    MatStepperModule,
    MatToolbarModule,
    MatRadioModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    MatOptionModule,
    MatSelectModule,
    MyMaterialModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FileDndModule,
    NgxMaskDirective,
    NgxMaskPipe,
    TranslocoModule
  ],
  declarations: [
    CertificateDeclarationComponent
  ],
  exports: [CertificateDeclarationComponent],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'es-AR'},
    {provide: DateAdapter, useClass: LuxonDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MAT_LUXON_DATE_FORMATS},
  ],
})

export class CertificateDeclarationModule { }


